<template>
  <div class="grid grid-flow-col grid-cols-8 gap-x-2">
    <label v-if="label" :for="id" class="flex leading-8 col-span-2">{{ label }}</label>
    <input @change="changeValue" :type="type" class="col-span-5 h-4 w-4 text-indigo-600 bg-gray-100 mt-2 rounded border border-gray-100 cursor-default focus:outline-none focus:ring focus:ring-indigo-200" :checked="modelValue">
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props:
  [
    "id",
    "label",
    "modelValue",
    "type",
    "mainSelectedNode",
    "model",
    "propertyName"
  ],
  
  methods: {
    changeValue(event) {
      event.target.value = event.target.checked
      this.$emit('changeValue', event, this.propertyName)
    }
  }
};
</script>
